var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivated2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7241",
    "data-name": "Group 7241",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 251.156,
    height: 335.122,
    viewBox: "0 0 251.156 335.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6010",
    "data-name": "Rectangle 6010",
    width: 251.156,
    height: 335.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6009",
    "data-name": "Rectangle 6009",
    width: 251.155,
    height: 335.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5991",
    "data-name": "Rectangle 5991",
    width: 0.392,
    height: 2.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5992",
    "data-name": "Rectangle 5992",
    width: 98.499,
    height: 76.181,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5993",
    "data-name": "Rectangle 5993",
    width: 116.129,
    height: 47.935,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5994",
    "data-name": "Rectangle 5994",
    width: 33.338,
    height: 12.729,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5995",
    "data-name": "Rectangle 5995",
    width: 33.342,
    height: 12.767,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5996",
    "data-name": "Rectangle 5996",
    width: 64.465,
    height: 39.475,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5997",
    "data-name": "Rectangle 5997",
    width: 14.903,
    height: 8.938,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5998",
    "data-name": "Rectangle 5998",
    width: 14.899,
    height: 10.146,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5999",
    "data-name": "Rectangle 5999",
    width: 116.519,
    height: 58.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6000",
    "data-name": "Rectangle 6000",
    width: 21.108,
    height: 21.482,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6001",
    "data-name": "Rectangle 6001",
    width: 17.82,
    height: 25.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6002",
    "data-name": "Rectangle 6002",
    width: 154.984,
    height: 97.419,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6003",
    "data-name": "Rectangle 6003",
    width: 21.074,
    height: 26.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6004",
    "data-name": "Rectangle 6004",
    width: 11.275,
    height: 12.198,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6005",
    "data-name": "Rectangle 6005",
    width: 120.306,
    height: 90.404,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6006",
    "data-name": "Rectangle 6006",
    width: 72.956,
    height: 59.353,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6007",
    "data-name": "Rectangle 6007",
    width: 149.486,
    height: 88.12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6008",
    "data-name": "Rectangle 6008",
    width: 149.484,
    height: 95.193,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7240",
    "data-name": "Group 7240",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7239",
    "data-name": "Group 7239",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7238",
    "data-name": "Group 7238",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M339.392,942.136h-77.61a24.763,24.763,0,0,1-24.69-24.69v-69.6a24.763,24.763,0,0,1,24.69-24.69h77.61a24.763,24.763,0,0,1,24.691,24.69v69.6a24.763,24.763,0,0,1-24.691,24.691",
    transform: "translate(-199.455 -692.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10509",
    "data-name": "Path 10509",
    d: "M237.107,847.445v70.421c0,13.352,11.3,24.281,25.107,24.281H338.99c13.806,0,25.107-10.929,25.107-24.281V847.445a23.377,23.377,0,0,0-2.607-10.738,24.513,24.513,0,0,0-4.813-6.455,25.457,25.457,0,0,0-16.418-7.055q-.635-.033-1.269-.033H262.2a25.245,25.245,0,0,0-22.827,14.225,23.647,23.647,0,0,0-1.151,2.9,23.322,23.322,0,0,0-1.117,7.153",
    transform: "translate(-199.469 -692.494)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M234.831,796.2h77.61a24.763,24.763,0,0,1,24.691,24.69v69.6a24.763,24.763,0,0,1-24.691,24.69h-77.61a24.763,24.763,0,0,1-24.69-24.69v-69.6a24.763,24.763,0,0,1,24.69-24.69m0-5.085a29.81,29.81,0,0,0-29.776,29.776v69.6a29.809,29.809,0,0,0,29.776,29.776h77.61a29.809,29.809,0,0,0,29.776-29.776v-69.6a29.81,29.81,0,0,0-29.776-29.776Z",
    transform: "translate(-172.504 -665.534)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7186",
    "data-name": "Group 7186",
    transform: "translate(40.322 156.557)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7185",
    "data-name": "Group 7185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7184",
    "data-name": "Group 7184",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M254.073,988.209l.328.17c.006-.157.005-.313,0-.469a4.888,4.888,0,0,0-.078-.641,1.522,1.522,0,0,0-.035-.163.577.577,0,0,0-.012-.067c-.015-.065-.033-.126-.05-.188s-.029-.107-.046-.159a.645.645,0,0,0-.024-.078c-.02-.059-.041-.117-.061-.173s-.053-.136-.079-.2c.015.073.031.146.043.219.028.155.049.316.063.474a5.36,5.36,0,0,1-.046,1.278",
    transform: "translate(-254.012 -986.238)",
    fill: "#6b184e"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M856.572,593.033l2.075,5.451,1.763,4.626,1.532,4.026,9.027,23.7c1.463.406,2.957.775,4.5,1.081,19.286,3.964,44.761-.225,79.527-39.21,5.439-6.1,18.561-9.79,12.841-23.65-5.852-14.179-14.085-12.41-14.085-12.41s2.157-7.027-2.494-10.584c-6.564-5.026-14.347,2.419-21.906,7.727-1.075.757-.594-9.427-7.7-9.121-10.159.438-9.615,23.625-9.615,23.625a87.04,87.04,0,0,1-34.978,21.674A66.517,66.517,0,0,1,859.5,593c-.963.031-1.944.044-2.926.031",
    transform: "translate(-720.599 -457.979)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7189",
    "data-name": "Group 7189",
    transform: "translate(150.145 98.955)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7188",
    "data-name": "Group 7188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7187",
    "data-name": "Group 7187",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M946.081,697.273h0c19.778,5.493,46.483,3.963,84.021-38.127,5.436-6.1,18.56-9.787,12.839-23.647-3.511-8.518-7.888-11.277-10.816-12.127.994,1.507,1.7,3.479,2.895,5.577,6.693,11.791-11.634,23.233-16.686,21.14-3.1-1.284-4.189-2.527-5.979-8.451-1.9-6.3-4.862-9.293-5.211-8.9-1.586,1.779-1.623,23.72-5.267,31.437-9.294,19.677-34.318,29.35-52.477,28.507a3.388,3.388,0,0,0-3.319,4.594",
    transform: "translate(-945.855 -623.371)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10514",
    "data-name": "Path 10514",
    d: "M873.569,622.236c17.288,0,40.447-8.094,70.024-41.257a32.973,32.973,0,0,1,4.765-4c5.717-4.261,13.546-10.1,8.523-22.269-4.24-10.274-9.876-13.114-13.456-13.811.244-2.947-.158-7.341-3.915-10.216-7.1-5.436-14.808.268-21.605,5.3l-.636.471c-.958-3.155-3.158-7.943-8.99-7.676-11.229.484-12.013,19.874-12.019,25.127-3.923,3.947-24.884,23.613-52.921,23.233h-.033a2.5,2.5,0,0,0-.031,5c33.3.419,56.379-24.49,57.345-25.551a2.5,2.5,0,0,0,.651-1.74c-.151-6.768,1.415-20.823,7.224-21.074,2.486-.1,3.459,1.88,4.379,5.586.383,1.54.712,2.869,2.173,3.415a2.677,2.677,0,0,0,2.473-.327c1.116-.784,2.239-1.615,3.361-2.445,7.141-5.286,11.754-8.284,15.591-5.346,3.192,2.442,1.637,7.825,1.621,7.879a2.505,2.505,0,0,0,2.921,3.167c.2-.031,6.363-.915,11.245,10.917,3.54,8.579-1.292,12.181-6.888,16.351a36.9,36.9,0,0,0-5.509,4.684c-38.454,43.118-64.921,41.982-81.484,37.379a2.5,2.5,0,0,0-1.339,4.819,61.073,61.073,0,0,0,16.532,2.388",
    transform: "translate(-707.336 -444.583)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10515",
    "data-name": "Path 10515",
    d: "M1295.733,585.312l.562,7.937a2.647,2.647,0,0,0,.453,1.308l.069.1h0a7.183,7.183,0,0,1,.522.652c.184.254.363.516.531.79a15,15,0,0,1,.915,1.7,12.138,12.138,0,0,1,1.124,5.576,11.469,11.469,0,0,1-.315,1.9,12.573,12.573,0,0,1-1.593,3.643l-.065.112a1.247,1.247,0,0,0,2.051,1.407,15.423,15.423,0,0,0,2.571-4.168,14.7,14.7,0,0,0,.756-2.41,16.08,16.08,0,0,0,.266-2.53,16.521,16.521,0,0,0-.678-5.014,19.609,19.609,0,0,0-.87-2.372c-.167-.388-.354-.77-.554-1.15a12.4,12.4,0,0,0-.709-1.2h0l.522,1.408-.578-8.16a2.5,2.5,0,0,0-4.987.353Z",
    transform: "translate(-1090.035 -490.046)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10516",
    "data-name": "Path 10516",
    d: "M1094.23,822.875a1.984,1.984,0,0,0,1.374-3.416c-13.442-12.9-15.5-44.041-15.517-44.354a1.984,1.984,0,0,0-3.961.241c.082,1.341,2.167,33,16.731,46.976a1.976,1.976,0,0,0,1.373.553",
    transform: "translate(-905.299 -650.496)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10517",
    "data-name": "Path 10517",
    d: "M95.93,937.132c1.069,23.631,8.3,33.221,17.217,36.247a17.453,17.453,0,0,0,5.964.932,25.479,25.479,0,0,0,10.9-2.882,10.774,10.774,0,0,0,4.457.769c16.5-1.6,12.734-11.39,9.384-27.076a109.527,109.527,0,0,1-2.294-14.948c-1.907-25.663,5.27-49.925,5.27-49.925l-2.763-23.025-3.076-25.663s-1.613,1.463-4.232,4.245c-2.294,2.432-5.357,5.864-8.777,10.209-13.953,17.692-33.9,50.4-32.046,91.117",
    transform: "translate(-80.601 -699.558)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10518",
    "data-name": "Path 10518",
    d: "M105.421,963.564q.266,0,.526-.009a28.681,28.681,0,0,0,11-2.67,12.193,12.193,0,0,0,4.512.544c6.223-.6,10.176-2.339,12.44-5.461,3.541-4.883,1.98-11.888,0-20.756a125.8,125.8,0,0,1-3.1-18.48c-1.849-24.876,5.1-48.792,5.17-49.03a2.5,2.5,0,0,0-4.8-1.417c-.3,1.009-7.281,25-5.362,50.818a129.929,129.929,0,0,0,3.206,19.2c1.7,7.639,3.048,13.673.83,16.732-1.343,1.853-4.246,2.971-8.874,3.42a8.153,8.153,0,0,1-3.264-.589l-1.139-.466-1.073.615a23.258,23.258,0,0,1-9.723,2.544,14.857,14.857,0,0,1-5.073-.8c-9.426-3.2-14.65-14.634-15.527-33.992-1.422-31.379,10.643-57.836,21.015-74.506a150.8,150.8,0,0,1,23.226-29.1,2.5,2.5,0,0,0-3.363-3.7c-.5.453-12.359,11.315-24.025,30.025-10.786,17.3-23.332,44.788-21.849,77.511.994,21.927,7.181,34.521,18.916,38.5a20.373,20.373,0,0,0,6.326,1.072",
    transform: "translate(-67.351 -686.304)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10519",
    "data-name": "Path 10519",
    d: "M148.531,1263.226a1.985,1.985,0,0,0,.677-3.85c-1.358-.493-33.375-11.936-45.01-1.473a1.984,1.984,0,1,0,2.654,2.951c8.194-7.37,32.377-.873,41,2.253a1.98,1.98,0,0,0,.676.119",
    transform: "translate(-87.105 -1054.526)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10520",
    "data-name": "Path 10520",
    d: "M271.558,830.289H387.87c.306-9.434.231-18.517-.125-27.2-.331-8.04-.913-15.735-1.675-23.043-.694-6.683-1.544-13.041-2.494-19.055-.125-.794-.275-1.569-.438-2.326-2.357-10.659-8.69-18.042-13.041-25.181-.738-1.213-1.419-2.413-2.013-3.626a25.606,25.606,0,0,1-1.669-4.251q-.056-.188-.094-.375a11.115,11.115,0,0,1,.85-5.483c1.563-4.407,4.439-9.253,3.632-11.647-1.338-3.945-2.5-7.046-3.363-9.234-.982-2.5-1.569-3.807-1.569-3.807H293.558s-.6,1.288-1.607,3.77c-1.044,2.57-2.52,6.414-4.207,11.459-1.044,3.113-2.169,6.683-3.32,10.684-.844,2.926-1.707,6.083-2.563,9.458-.406,1.607-.813,3.263-1.207,4.964-1.888,7.965-3.695,16.992-5.207,27.007-.857,5.614-1.613,11.528-2.232,17.742-.744,7.339-1.294,15.085-1.6,23.2-.325,8.571-.369,17.573-.056,26.944",
    transform: "translate(-228.272 -584.725)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10521",
    "data-name": "Path 10521",
    d: "M944.54,981.289a55.575,55.575,0,0,0,.105,5.747c.077,1.9.279,3.754.446,5.618s.448,3.7.7,5.546c.289,1.838.668,3.659.995,5.495l.5,2.751c.15.92.273,1.845.4,2.768q.385,2.77.7,5.553.34,2.778.608,5.568.3,2.785.527,5.58c.681,7.447.88,14.935,1.153,22.417.169,3.74.33,7.482.608,11.224.211,3.745.427,7.485,2.5,11.2a.434.434,0,0,0,.766-.014c1.922-3.8,1.97-7.577,1.953-11.348.043-3.774-.057-7.547-.236-11.318-.406-7.542-1.132-15.067-1.763-22.6q-.236-2.826-.534-5.649-.274-2.825-.617-5.645-.314-2.822-.709-5.638l-.711-5.644c-.21-1.886-.484-3.768-.836-5.634s-.846-3.71-1.376-5.54a50.265,50.265,0,0,0-4.436-10.631.4.4,0,0,0-.741.175Z",
    transform: "translate(-794.569 -825.19)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10522",
    "data-name": "Path 10522",
    d: "M260.185,1117.081c2.061-3.357,2.263-6.742,2.438-10.125.245-3.38.376-6.757.5-10.13.2-6.744.372-13.481,1.086-20.174.333-3.348.743-6.688,1.206-10.021s.932-6.67,1.651-9.966c.332-1.652.695-3.3.977-4.961.257-1.666.461-3.344.627-5.033s.239-3.4.293-5.115a40.492,40.492,0,0,0-.156-5.231v-.01a.4.4,0,0,0-.441-.356.4.4,0,0,0-.306.2,48.412,48.412,0,0,0-4.017,9.593,54.489,54.489,0,0,0-2.105,10.032c-.439,3.393-1.019,6.765-1.476,10.158s-.888,6.791-1.227,10.2c-.67,6.815-1.366,13.635-1.7,20.458-.139,3.412-.209,6.82-.133,10.228.018,3.4.081,6.807,2.018,10.237a.445.445,0,0,0,.606.169.451.451,0,0,0,.161-.155",
    transform: "translate(-216.515 -871.509)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7192",
    "data-name": "Group 7192",
    transform: "translate(43.341 188.792)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7191",
    "data-name": "Group 7191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7190",
    "data-name": "Group 7190",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10523",
    "data-name": "Path 10523",
    d: "M273.031,1224.61c7.137.7,16.042.949,22.955-.862v3.836a9.691,9.691,0,0,0,9.663,9.657h52.72a9.685,9.685,0,0,0,9.653-9.657v-3.067c6.891,1.047,14.913.595,21.138-.109-.327-6.406-.911-12.539-1.675-18.361a161.106,161.106,0,0,1-19.463-.207v-6.881a9.673,9.673,0,0,0-9.653-9.652H305.65a9.667,9.667,0,0,0-7.688,3.825,9.564,9.564,0,0,0-1.975,5.828v6.449c-6.417.933-14.716.933-21.356.715-.742,5.849-1.293,12.021-1.6,18.486",
    transform: "translate(-273.031 -1189.307)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10524",
    "data-name": "Path 10524",
    d: "M807.183,1263.31c7.249,2.935,18.468,2.32,26.116,1.4a8.218,8.218,0,0,0-1.369-16.366c-7.154.335-17.885.492-24.68-1.015",
    transform: "translate(-679.05 -1049.322)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7195",
    "data-name": "Group 7195",
    transform: "translate(128.131 203.419)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7194",
    "data-name": "Group 7194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7193",
    "data-name": "Group 7193",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10525",
    "data-name": "Path 10525",
    d: "M807.172,1292.023c7.251,2.939,18.47,2.319,26.118,1.4a8.228,8.228,0,0,0,6.287-11.966,8.2,8.2,0,0,1-6.287,4.344c-7.635.927-18.834,1.54-26.086-1.38Z",
    transform: "translate(-807.172 -1281.456)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10526",
    "data-name": "Path 10526",
    d: "M774.824,1252.262h0c-5.49-2.223-5.719-10.746-4.146-15.807,1.674-5.383,4.783-5.141,5.694-4.939,5,1.11,13.533,1.45,24.021.959a10.718,10.718,0,0,1,1.786,21.347,101.458,101.458,0,0,1-11.994.781c-5.491,0-11.032-.589-15.361-2.341m.931-2.318h0Zm24.872-12.474c-7.459.349-17.662.463-24.612-.919a14.085,14.085,0,0,0-1,8c.139.776.581,2.629,1.685,3.076,5.2,2.106,14.036,2.542,24.878,1.23a5.717,5.717,0,0,0-.679-11.392c-.09,0-.181,0-.273.006",
    transform: "translate(-647.63 -1035.956)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10527",
    "data-name": "Path 10527",
    d: "M281.212,1263.31c-7.249,2.935-18.468,2.32-26.116,1.4a8.218,8.218,0,0,1,1.369-16.366c7.154.335,17.884.492,24.68-1.015",
    transform: "translate(-208.527 -1049.322)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7198",
    "data-name": "Group 7198",
    transform: "translate(39.346 203.381)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7197",
    "data-name": "Group 7197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7196",
    "data-name": "Group 7196",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10528",
    "data-name": "Path 10528",
    d: "M255.087,1293.219c7.647.92,18.866,1.54,26.118-1.4l-.032-7.673c-7.251,2.92-18.451,2.306-26.086,1.38a8.175,8.175,0,0,1-6.268-4.312,8.216,8.216,0,0,0,6.268,12",
    transform: "translate(-247.862 -1281.214)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10529",
    "data-name": "Path 10529",
    d: "M241.535,1253.82a10.718,10.718,0,0,1,1.786-21.347c10.49.491,19.02.151,24.022-.959.912-.2,4.02-.444,5.693,4.939,1.574,5.061,1.344,13.584-4.146,15.807-4.329,1.753-9.869,2.341-15.361,2.341a101.565,101.565,0,0,1-11.994-.781m25.479-6.2c1.1-.447,1.546-2.3,1.685-3.076a14.083,14.083,0,0,0-1-8c-6.949,1.382-17.153,1.269-24.612.919a5.717,5.717,0,0,0-.951,11.386c10.842,1.313,19.677.875,24.878-1.23",
    transform: "translate(-195.266 -1035.955)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10530",
    "data-name": "Path 10530",
    d: "M440.237,1168.266v25.619a8.671,8.671,0,0,0,8.644,8.644h47.182a8.67,8.67,0,0,0,8.638-8.644v-25.619a8.664,8.664,0,0,0-8.638-8.638H448.881a8.663,8.663,0,0,0-8.644,8.638",
    transform: "translate(-370.354 -975.548)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7201",
    "data-name": "Group 7201",
    transform: "translate(69.884 187.505)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7200",
    "data-name": "Group 7200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7199",
    "data-name": "Group 7199",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10531",
    "data-name": "Path 10531",
    d: "M440.239,1186.417v25.62a8.667,8.667,0,0,0,8.642,8.642h47.181a8.667,8.667,0,0,0,8.642-8.642v-9.582c-7.086,7.224-21.021,11.76-33.8,11.828a7.769,7.769,0,0,1-7.712-7.323c0-.041-.006-.082-.01-.123a7.453,7.453,0,0,0-14.836-.1c-6.186-7.637-4.375-20.912-6.342-25.534a8.563,8.563,0,0,0-1.763,5.213",
    transform: "translate(-440.239 -1181.204)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10532",
    "data-name": "Path 10532",
    d: "M424.5,1180.625V1155a11.152,11.152,0,0,1,11.14-11.14h47.183a11.153,11.153,0,0,1,11.14,11.14v25.623a11.153,11.153,0,0,1-11.14,11.14H435.636a11.153,11.153,0,0,1-11.14-11.14m11.14-31.762A6.146,6.146,0,0,0,429.5,1155v25.623a6.146,6.146,0,0,0,6.139,6.139h47.183a6.146,6.146,0,0,0,6.139-6.139V1155a6.146,6.146,0,0,0-6.139-6.139Z",
    transform: "translate(-357.111 -962.285)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10533",
    "data-name": "Path 10533",
    d: "M491.056,1255.261a7.451,7.451,0,1,0,7.451-7.451,7.451,7.451,0,0,0-7.451,7.451",
    transform: "translate(-413.106 -1049.732)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7204",
    "data-name": "Group 7204",
    transform: "translate(77.951 198.08)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7203",
    "data-name": "Group 7203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7202",
    "data-name": "Group 7202",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10534",
    "data-name": "Path 10534",
    d: "M491.057,1255.27a7.561,7.561,0,0,0,.145,1.489,7.456,7.456,0,0,1,14.613,0,7.554,7.554,0,0,0,.145-1.489,7.452,7.452,0,0,0-14.9,0",
    transform: "translate(-491.057 -1247.821)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7207",
    "data-name": "Group 7207",
    transform: "translate(77.953 202.832)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7206",
    "data-name": "Group 7206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7205",
    "data-name": "Group 7205",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10535",
    "data-name": "Path 10535",
    d: "M491.069,1280.449a7.449,7.449,0,1,0,14.9,0,7.28,7.28,0,0,0-.511-2.7,7.444,7.444,0,0,1-13.877,0,7.28,7.28,0,0,0-.511,2.7",
    transform: "translate(-491.069 -1277.753)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M479.242,1245.323a9.326,9.326,0,1,1,9.326,9.326,9.337,9.337,0,0,1-9.326-9.326m3.751,0a5.575,5.575,0,1,0,5.575-5.575,5.582,5.582,0,0,0-5.575,5.575",
    transform: "translate(-403.167 -1039.794)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10537",
    "data-name": "Path 10537",
    d: "M661.064,1194.453a1.875,1.875,0,0,0,1.875-1.875v-13.611a7.5,7.5,0,0,1,2.974-5.961l1.993-1.5a11.268,11.268,0,0,0,4.469-8.958v-12.871a1.875,1.875,0,0,0-3.751,0v12.871a7.5,7.5,0,0,1-2.974,5.961l-1.993,1.5a11.267,11.267,0,0,0-4.469,8.957v13.611a1.875,1.875,0,0,0,1.875,1.875",
    transform: "translate(-554.549 -965.598)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7210",
    "data-name": "Group 7210",
    transform: "translate(44.934 110.335)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7209",
    "data-name": "Group 7209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7208",
    "data-name": "Group 7208",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10538",
    "data-name": "Path 10538",
    d: "M283.068,733.645c1.709,1.589,3.5,3.092,5.349,4.5a76.949,76.949,0,0,0,11.833,7.472,76.47,76.47,0,0,0,83.191-9.088c.174-.134.347-.281.514-.427a76.655,76.655,0,0,0,15.633-17.909,71.047,71.047,0,0,1-18.758,3.238c1.669-4.708,4.741-9.883,3.88-12.44-1.429-4.214-2.671-7.526-3.592-9.863-1.048-2.671-1.676-4.067-1.676-4.067H302.2s-.641,1.376-1.716,4.027c-1.115,2.745-2.691,6.851-4.494,12.24-1.115,3.325-2.317,7.138-3.546,11.412-2.451,2.6-5.723,6.264-9.376,10.9",
    transform: "translate(-283.068 -695.061)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10539",
    "data-name": "Path 10539",
    d: "M38.152,468.131h0a1.581,1.581,0,0,0,1.345-1.786l-6.348-45.082a1.581,1.581,0,0,0-1.786-1.345A16.582,16.582,0,0,0,17.255,438.65l2.165,15.373a16.582,16.582,0,0,0,18.732,14.108",
    transform: "translate(-14.378 -353.246)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10540",
    "data-name": "Path 10540",
    d: "M16.349,451.512l-2.165-15.373a17.07,17.07,0,0,1,14.522-19.282,2.068,2.068,0,0,1,2.336,1.759L37.39,463.7a2.068,2.068,0,0,1-1.759,2.336,17.06,17.06,0,0,1-19.282-14.522m12.493-33.69A16.113,16.113,0,0,0,15.149,436l2.165,15.373A16.111,16.111,0,0,0,35.5,465.069a1.093,1.093,0,0,0,.93-1.235l-6.348-45.083a1.093,1.093,0,0,0-1.235-.93",
    transform: "translate(-11.79 -350.667)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7213",
    "data-name": "Group 7213",
    transform: "translate(4.027 93.569)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7212",
    "data-name": "Group 7212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7211",
    "data-name": "Group 7211",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10541",
    "data-name": "Path 10541",
    d: "M25.367,589.436l1.014,7.21a16.589,16.589,0,0,0,18.735,14.109,1.584,1.584,0,0,0,1.345-1.789l-1.684-11.985a1.584,1.584,0,0,1-1.293,1.129l-1.069.148a16.569,16.569,0,0,1-17.046-8.822",
    transform: "translate(-25.367 -589.437)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10542",
    "data-name": "Path 10542",
    d: "M2.357,440.026.193,424.653a19.293,19.293,0,0,1,16.415-21.795,4.291,4.291,0,0,1,4.848,3.651L27.8,451.591a4.291,4.291,0,0,1-3.651,4.85A19.281,19.281,0,0,1,2.357,440.026m13.892-31.6A13.889,13.889,0,0,0,5.563,423.9L7.727,439.27A13.887,13.887,0,0,0,22.27,451.183Z",
    transform: "translate(-0.001 -338.871)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10543",
    "data-name": "Path 10543",
    d: "M1037.209,287.132h0a1.581,1.581,0,0,0-1.345,1.786L1042.212,334a1.581,1.581,0,0,0,1.786,1.345,16.582,16.582,0,0,0,14.108-18.732l-2.165-15.373a16.582,16.582,0,0,0-18.732-14.108",
    transform: "translate(-871.418 -241.414)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10544",
    "data-name": "Path 10544",
    d: "M1039.146,331.483,1032.8,286.4a2.069,2.069,0,0,1,1.76-2.336,17.07,17.07,0,0,1,19.282,14.522L1056,313.96a17.069,17.069,0,0,1-14.522,19.282,2.1,2.1,0,0,1-.289.02,2.071,2.071,0,0,1-2.046-1.78m-4.453-46.453h0a1.093,1.093,0,0,0-.93,1.235l6.348,45.082a1.091,1.091,0,0,0,1.235.93,16.093,16.093,0,0,0,13.693-18.182l-2.164-15.373a16.1,16.1,0,0,0-15.9-13.853,16.327,16.327,0,0,0-2.278.16",
    transform: "translate(-868.834 -238.829)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7216",
    "data-name": "Group 7216",
    transform: "translate(169.03 68.724)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7215",
    "data-name": "Group 7215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7214",
    "data-name": "Group 7214",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10545",
    "data-name": "Path 10545",
    d: "M1064.82,444.286l1.763,12.507a1.584,1.584,0,0,0,1.789,1.345,16.575,16.575,0,0,0,14.105-18.729l-.912-6.478a16.588,16.588,0,0,1-13.6,11.75l-1.645.231a1.6,1.6,0,0,1-1.5-.626",
    transform: "translate(-1064.82 -432.93)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10546",
    "data-name": "Path 10546",
    d: "M1025.154,320l-6.348-45.083a4.292,4.292,0,0,1,3.652-4.848h0a19.293,19.293,0,0,1,21.795,16.415l2.165,15.373a19.294,19.294,0,0,1-16.414,21.8,4.347,4.347,0,0,1-.6.042,4.3,4.3,0,0,1-4.247-3.694m-.814-44.674,6.02,42.754a13.872,13.872,0,0,0,10.687-15.467l-2.165-15.373a13.875,13.875,0,0,0-13.706-11.939q-.417,0-.837.025m-1.126.113h0Z",
    transform: "translate(-857.044 -227.035)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10547",
    "data-name": "Path 10547",
    d: "M109.931,110.871a77.582,77.582,0,1,0,59.624-92.1,77.582,77.582,0,0,0-59.624,92.1",
    transform: "translate(-91.021 -14.329)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10548",
    "data-name": "Path 10548",
    d: "M106.91,108.427h0a78.023,78.023,0,1,1,76.323,61.736,78.158,78.158,0,0,1-76.323-61.736m60.2-91.729a77.049,77.049,0,1,0,16.154-1.716A77.183,77.183,0,0,0,167.112,16.7",
    transform: "translate(-88.477 -11.783)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7219",
    "data-name": "Group 7219",
    transform: "translate(17.389 60.482)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7218",
    "data-name": "Group 7218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7217",
    "data-name": "Group 7217",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10549",
    "data-name": "Path 10549",
    d: "M109.543,406.414a77.585,77.585,0,1,0,153.25-21.822c-.257-1.2-.543-2.4-.855-3.58a77.585,77.585,0,0,1-152.4,25.4",
    transform: "translate(-109.543 -381.012)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M92.946,97.106h0a80.245,80.245,0,1,1,78.5,63.5,80.385,80.385,0,0,1-78.5-63.5M155.788,7.087A74.828,74.828,0,1,0,171.477,5.42a74.956,74.956,0,0,0-15.688,1.667M95.59,96.539h0Z",
    transform: "translate(-76.688 0.003)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10551",
    "data-name": "Path 10551",
    d: "M116.8,230.685a69.586,69.586,0,0,0,21.065,37.558c7.9,7.347,36.354,17.3,67.872,11.346,29.224-5.523,52.682-26.34,57.179-36.145a69.586,69.586,0,0,0,5.138-42.754c-7.815-39.408-44.912-49.03-86.682-40.746s-72.387,31.335-64.572,70.742",
    transform: "translate(-97.232 -132.246)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7222",
    "data-name": "Group 7222",
    transform: "translate(32.55 74.923)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7221",
    "data-name": "Group 7221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7220",
    "data-name": "Group 7220",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10552",
    "data-name": "Path 10552",
    d: "M224.845,481.622c2.777,7.056.885,14.407-4.228,16.419s-11.509-2.075-14.286-9.131-.884-14.407,4.228-16.42,11.509,2.075,14.286,9.131",
    transform: "translate(-205.05 -471.978)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7225",
    "data-name": "Group 7225",
    transform: "translate(54.695 106.419)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7224",
    "data-name": "Group 7224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7223",
    "data-name": "Group 7223",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10553",
    "data-name": "Path 10553",
    d: "M354.9,673.829c1.71,3.031.988,6.678-1.614,8.146s-6.1.2-7.807-2.831-.987-6.678,1.614-8.146,6.1-.2,7.806,2.831",
    transform: "translate(-344.554 -670.388)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7228",
    "data-name": "Group 7228",
    transform: "translate(18.349 58.758)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7227",
    "data-name": "Group 7227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7226",
    "data-name": "Group 7226",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10554",
    "data-name": "Path 10554",
    d: "M124.228,370.147c-7.5,10.655-10.554,23.85-7.418,39.678a69.624,69.624,0,0,0,21.062,37.561c7.9,7.346,36.358,17.3,67.876,11.348a95.69,95.69,0,0,0,30.146-11.513c-38.9,6.492-73.589-5.773-83.385-14.886a88.3,88.3,0,0,1-26.732-47.667,78.551,78.551,0,0,1-1.55-14.522",
    transform: "translate(-115.589 -370.147)",
    fill: "#111a28"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10555",
    "data-name": "Path 10555",
    d: "M108.3,143.9a2.406,2.406,0,0,0,1.856-.869l.209-.244.143-.316c9.2-20.387,31.808-35.518,62.038-41.515,30.4-6.027,57.11-.334,73.294,15.62l.186.165a2.41,2.41,0,0,0,3.151-3.645c-17.344-17.057-45.612-23.207-77.569-16.869-31.722,6.292-55.565,22.376-65.442,44.143a2.411,2.411,0,0,0,2.133,3.53",
    transform: "translate(-89.083 -78.901)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7231",
    "data-name": "Group 7231",
    transform: "translate(85.865 35.901)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7230",
    "data-name": "Group 7230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7229",
    "data-name": "Group 7229",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10556",
    "data-name": "Path 10556",
    d: "M613.539,285.517s4.5-41.3-19.528-52.633-54.154-5.3-53.066-3.5c0,0,34.973,1.461,53.262,25.253,14.1,18.347,19.333,30.883,19.333,30.883",
    transform: "translate(-540.916 -226.164)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10557",
    "data-name": "Path 10557",
    d: "M229.465,2080.026a1.918,1.918,0,1,0,1.918-1.918,1.918,1.918,0,0,0-1.918,1.918",
    transform: "translate(-193.04 -1748.228)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7234",
    "data-name": "Group 7234",
    transform: "translate(23.649 241.968)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7233",
    "data-name": "Group 7233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7232",
    "data-name": "Group 7232",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10558",
    "data-name": "Path 10558",
    d: "M205.968,1526.209a48.775,48.775,0,0,0-48.776,13.135c-20.295,20.625,3.426,40.975,3.426,40.975s-7.31,28.106,11.67,31.711c16.108,3.059,30.663-12.51,28.8-31.771-1.53-15.838-5.008-14.363-3.727-23.05,1.451-9.836,22.417-12.05,22.417-12.05h7.887s20.966,2.215,22.417,12.05c1.282,8.687-2.2,7.212-3.726,23.05-1.86,19.261,12.7,34.83,28.8,31.771,18.98-3.6,11.67-31.711,11.67-31.711s23.721-20.35,3.426-40.975a48.775,48.775,0,0,0-48.776-13.135Z",
    transform: "translate(-148.983 -1524.296)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10559",
    "data-name": "Path 10559",
    d: "M118.351,1451.391s-32.343-18.854-59.1,8.341c-24.591,24.991,4.152,49.649,4.152,49.649s-8.857,34.056,14.141,38.424c19.518,3.707,37.155-15.158,34.9-38.5-1.854-19.191-6.068-17.4-4.515-27.929,1.758-11.918,27.162-14.6,27.162-14.6h9.556s25.4,2.684,27.162,14.6c1.552,10.526-2.661,8.738-4.515,27.929-2.254,23.339,15.383,42.2,34.9,38.5,23-4.368,14.141-38.424,14.141-38.424s28.743-24.658,4.152-49.649c-26.759-27.195-59.1-8.341-59.1-8.341",
    transform: "translate(-41.475 -1215.642)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7237",
    "data-name": "Group 7237",
    transform: "translate(23.649 237.439)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7236",
    "data-name": "Group 7236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7235",
    "data-name": "Group 7235",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10560",
    "data-name": "Path 10560",
    d: "M148.982,1582.906c2.37,3.559,6.248,6.418,12.415,7.586,19.519,3.708,37.157-15.162,34.9-38.5-1.854-19.193-6.065-17.407-4.516-27.927,1.759-11.919,27.167-14.6,27.167-14.6h9.556s25.4,2.683,27.16,14.6c1.555,10.52-2.662,8.734-4.516,27.927-2.255,23.336,15.383,42.206,34.9,38.5,6.167-1.168,10.045-4.027,12.415-7.586-.17.034-.34.068-.509.1-23.248,4.014-44.254-15.9-41.572-41.174,2.214-20.782,7.233-18.847,5.379-30.25-2.092-12.9-32.349-15.811-32.349-15.811H218.032s-30.257,2.907-32.348,15.811c-1.847,11.4,3.172,9.468,5.379,30.25,2.683,25.278-18.324,45.188-41.572,41.174-.17-.027-.34-.061-.509-.1",
    transform: "translate(-148.982 -1495.766)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10561",
    "data-name": "Path 10561",
    d: "M105.543,1436.752a46.22,46.22,0,0,0-14.162-6.352,51.133,51.133,0,0,0-7.722-1.458,51.726,51.726,0,0,0-7.922-.162,47.2,47.2,0,0,0-7.884,1.2,47.862,47.862,0,0,0-7.582,2.547,52.319,52.319,0,0,0-13.285,8.7A44.826,44.826,0,0,0,37,1453.684,33.1,33.1,0,0,0,34.2,1461.4a29.611,29.611,0,0,0-.536,8.23,36.355,36.355,0,0,0,4.93,15.322,51.547,51.547,0,0,0,4.478,6.558c.83,1.026,1.683,2.033,2.588,3,.45.485.909.962,1.383,1.431s.93.912,1.507,1.418l-.792-2.527c-.458,1.868-.765,3.591-1.039,5.4q-.4,2.684-.58,5.4a50.674,50.674,0,0,0,.377,10.984,35.022,35.022,0,0,0,1.314,5.5,26.566,26.566,0,0,0,2.465,5.266,21.253,21.253,0,0,0,3.905,4.515A20.783,20.783,0,0,0,59.308,1535a25.163,25.163,0,0,0,5.625,1.514c.938.172,1.9.216,2.845.3.955.011,1.912.066,2.866-.011a27.076,27.076,0,0,0,5.658-.856A28.162,28.162,0,0,0,81.663,1534a34.886,34.886,0,0,0,15.719-15.612,41.728,41.728,0,0,0,4.442-21.543c-.1-1.875-.337-3.6-.537-5.38l-.38-2.661-.47-2.663c-.368-1.773-.763-3.554-1.287-5.3-.5-1.745-1.123-3.467-1.591-5a14.058,14.058,0,0,1-.684-4.425,10.738,10.738,0,0,1,.042-1.157c.025-.391.042-.779.1-1.186l.148-1.207c.077-.322.118-.617.208-.92.711-2.392,3.01-4.509,5.766-6.05a40.654,40.654,0,0,1,9.131-3.6,69.424,69.424,0,0,1,9.85-1.952l-.263.014h9.556l-.263-.014A69.431,69.431,0,0,1,141,1457.3a40.659,40.659,0,0,1,9.131,3.6c2.756,1.541,5.055,3.658,5.766,6.05.09.3.132.6.208.92l.148,1.207c.061.407.078.8.1,1.186a10.747,10.747,0,0,1,.043,1.157,14.063,14.063,0,0,1-.684,4.425c-.468,1.535-1.093,3.257-1.591,5-.524,1.747-.919,3.528-1.287,5.3l-.47,2.663-.38,2.661c-.2,1.785-.434,3.5-.537,5.38a41.724,41.724,0,0,0,4.442,21.543A34.886,34.886,0,0,0,171.616,1534a28.159,28.159,0,0,0,5.361,1.945,27.073,27.073,0,0,0,5.658.856c.954.077,1.911.022,2.866.011.95-.086,1.907-.131,2.845-.3a25.161,25.161,0,0,0,5.624-1.514,20.787,20.787,0,0,0,5.113-3.105,21.257,21.257,0,0,0,3.905-4.515,26.575,26.575,0,0,0,2.465-5.266,35.057,35.057,0,0,0,1.314-5.5,50.675,50.675,0,0,0,.377-10.984q-.179-2.717-.58-5.4c-.274-1.807-.581-3.529-1.039-5.4l-.792,2.527c.578-.507,1.023-.939,1.507-1.418s.933-.946,1.383-1.431c.9-.965,1.757-1.972,2.588-3a51.527,51.527,0,0,0,4.478-6.558,36.163,36.163,0,0,0,4.922-15.323,29.6,29.6,0,0,0-.564-8.221,32.941,32.941,0,0,0-2.832-7.7,44.621,44.621,0,0,0-10.042-12.365,52.357,52.357,0,0,0-13.215-8.717,44.642,44.642,0,0,0-15.4-4.035,49.857,49.857,0,0,0-7.955.1,51.467,51.467,0,0,0-7.768,1.41,48.417,48.417,0,0,0-7.363,2.673,35.38,35.38,0,0,0-6.735,3.973.84.84,0,0,0,.788,1.458l.052-.018a86.351,86.351,0,0,1,14.226-3.626c2.389-.4,4.787-.614,7.176-.77,1.2-.014,2.391-.085,3.581-.033.6.017,1.191.015,1.785.046l1.777.129a44.221,44.221,0,0,1,13.746,3.391,40.79,40.79,0,0,1,6.28,3.383,44.6,44.6,0,0,1,5.7,4.372,39.668,39.668,0,0,1,8.935,10.947,27.952,27.952,0,0,1,2.378,6.444,24.585,24.585,0,0,1,.462,6.8,31.2,31.2,0,0,1-4.276,13.2,46.542,46.542,0,0,1-4.037,5.909c-.754.931-1.529,1.849-2.348,2.721-.407.438-.821.869-1.242,1.286s-.872.849-1.242,1.173l-1.162,1.018.37,1.509c.372,1.519.687,3.232.932,4.873.247,1.66.427,3.33.537,5a45.741,45.741,0,0,1-.33,9.886,30.1,30.1,0,0,1-1.111,4.667,21.645,21.645,0,0,1-1.953,4.192,16.3,16.3,0,0,1-2.911,3.371,15.817,15.817,0,0,1-3.8,2.3,20.189,20.189,0,0,1-4.454,1.188c-.778.148-1.568.175-2.353.253-.788,0-1.576.058-2.362-.011a22.069,22.069,0,0,1-4.665-.707,23.154,23.154,0,0,1-4.455-1.617,29.9,29.9,0,0,1-13.423-13.391,36.726,36.726,0,0,1-3.891-18.956c.085-1.608.315-3.349.5-5.028l.359-2.517.439-2.488c.342-1.641.7-3.268,1.181-4.862.457-1.609,1.028-3.168,1.58-4.967a19.192,19.192,0,0,0,.894-5.871c.015-.5-.02-.977-.052-1.455s-.056-.962-.122-1.419l-.171-1.389c-.106-.529-.206-1.1-.365-1.629a13.286,13.286,0,0,0-3.36-5.441,21.683,21.683,0,0,0-4.718-3.52,45.46,45.46,0,0,0-10.278-4.076,74.034,74.034,0,0,0-10.658-2.105l-.114-.014h-9.855l-.113.014a74.026,74.026,0,0,0-10.658,2.105,45.465,45.465,0,0,0-10.278,4.076,21.69,21.69,0,0,0-4.718,3.52,13.287,13.287,0,0,0-3.36,5.441c-.16.53-.26,1.1-.365,1.629l-.171,1.389c-.066.457-.092.939-.122,1.419s-.067.954-.052,1.455a19.193,19.193,0,0,0,.894,5.871c.552,1.8,1.123,3.358,1.58,4.967.48,1.594.838,3.221,1.181,4.862l.439,2.488.359,2.517c.189,1.68.42,3.42.5,5.028A36.726,36.726,0,0,1,92.94,1516.1a29.9,29.9,0,0,1-13.423,13.391,23.154,23.154,0,0,1-4.455,1.617,22.069,22.069,0,0,1-4.665.707c-.786.069-1.575.014-2.362.011-.785-.078-1.575-.105-2.353-.253a20.2,20.2,0,0,1-4.454-1.188,15.822,15.822,0,0,1-3.8-2.3,16.292,16.292,0,0,1-2.911-3.371,21.647,21.647,0,0,1-1.954-4.192,30.1,30.1,0,0,1-1.111-4.667,45.741,45.741,0,0,1-.329-9.886c.11-1.668.29-3.338.537-5,.245-1.641.56-3.354.932-4.873l.37-1.509-1.162-1.018c-.37-.324-.833-.766-1.242-1.173s-.835-.848-1.242-1.286c-.819-.872-1.594-1.79-2.348-2.721a46.541,46.541,0,0,1-4.037-5.909,31,31,0,0,1-4.268-13.2,24.555,24.555,0,0,1,.49-6.795,27.822,27.822,0,0,1,2.4-6.421,40.056,40.056,0,0,1,8.986-10.856,48.422,48.422,0,0,1,11.91-7.789,44.117,44.117,0,0,1,13.694-3.647,54.707,54.707,0,0,1,14.394.514,68.548,68.548,0,0,1,14.165,3.908l.057.023a.835.835,0,0,0,.783-1.463",
    transform: "translate(-28.247 -1201.723)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10562",
    "data-name": "Path 10562",
    d: "M122.379,1838.9l1.72.547c.635.18,1.274.344,1.919.468a23.049,23.049,0,0,0,3.852.439,30.782,30.782,0,0,0,7.45-.728,43.4,43.4,0,0,0,6.913-2.252c1.116-.439,2.178-1,3.26-1.495,1.058-.551,2.1-1.133,3.136-1.694-1.128.373-2.244.761-3.367,1.113-1.145.293-2.261.654-3.41.885a41.545,41.545,0,0,1-6.866.964,27.621,27.621,0,0,1-6.679-.519,18.964,18.964,0,0,1-3.09-.923c-.495-.189-.972-.41-1.444-.639l-1.549-.816a2.514,2.514,0,1,0-1.947,4.617Z",
    transform: "translate(-101.402 -1542.838)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10563",
    "data-name": "Path 10563",
    d: "M954.379,1834.252l-1.549.816c-.472.229-.95.45-1.444.639a18.974,18.974,0,0,1-3.09.922,27.6,27.6,0,0,1-6.679.519,41.519,41.519,0,0,1-6.866-.964c-1.149-.231-2.265-.592-3.41-.885-1.123-.353-2.239-.741-3.367-1.113,1.04.561,2.078,1.143,3.136,1.694,1.082.492,2.144,1.055,3.26,1.495a43.374,43.374,0,0,0,6.913,2.252,30.786,30.786,0,0,0,7.45.728,23.078,23.078,0,0,0,3.852-.439c.644-.123,1.283-.288,1.918-.468l1.72-.547.09-.028a2.514,2.514,0,1,0-1.523-4.792,2.685,2.685,0,0,0-.41.171",
    transform: "translate(-780.667 -1542.837)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10564",
    "data-name": "Path 10564",
    d: "M44.231,1642.354a1.877,1.877,0,0,0,1.836-2.269c-.864-4.033-.234-6.893,1.924-8.745,8.95-7.679,41.112,2.131,52.749,6.56a1.875,1.875,0,1,0,1.334-3.506c-4.5-1.711-44.277-16.41-56.525-5.9-3.252,2.79-4.312,6.954-3.15,12.377a1.876,1.876,0,0,0,1.832,1.483",
    transform: "translate(-35.285 -1366.826)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10565",
    "data-name": "Path 10565",
    d: "M865.6,1642.354a1.875,1.875,0,0,0,1.832-1.483c1.162-5.423.1-9.588-3.15-12.377-12.248-10.509-52.029,4.19-56.525,5.9a1.875,1.875,0,1,0,1.334,3.506c11.639-4.427,43.8-14.235,52.749-6.56,2.158,1.852,2.788,4.713,1.924,8.745a1.877,1.877,0,0,0,1.836,2.269",
    transform: "translate(-678.516 -1366.826)",
    fill: "#292d39"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated2);
export default __webpack_public_path__ + "static/media/activated2.81edcad390eed5692748fe7053409338.svg";
export { ForwardRef as ReactComponent };